import { AccessLevel } from './conferences';

export enum BroadcastStatus {
    NONE = 'NONE',
    CREATED = 'CREATED',
    /** @deprecated в пользу STARTED */
    STARTING = 'STARTING',
    STARTED = 'STARTED',
    /** @deprecated в пользу PAUSED */
    FINISHED = 'FINISHED',
    ONAIR = 'ONAIR',
    ENDED = 'ENDED',
    PAUSED = 'PAUSED',
}

export enum BroadcastTutorialStep {
    CREATED = 'CREATED',
    STARTED = 'STARTED',
    FINISHED = 'FINISHED',
    COMPLETED = 'COMPLETED',
}

export type UgcLiveStatus = 'offline' | 'preparing' | 'ready' | 'onair' | 'finished';

interface BroadcastCommonInfo {
    status: BroadcastStatus;
    /**
     * Урл плеера из STRM
     */
    player_url?: string;
    /**
     * Количество зрителей
     */
    viewers?: number;
}

export interface BroadcastState extends BroadcastCommonInfo {
    /**
     * Время, когда STRM на своей стороне начинает принимать сигнал от транслятора,
     * общий формат между общий ISO 8601 и RFC 3339
     * @example '2018-01-28T12:08:48.372+03:00', '2018-01-28'
     */
    started_at?: string;
    /**
     * Время поллинга, которое контролирует бэк
     */
    refresh_interval_ms?: number;
}

export interface BroadcastInfo extends BroadcastCommonInfo {
    /**
     * Флаг, определяющий признак использования нового API трансляций (STRM)
     */
    ugc_live?: boolean;
    caption?: string;
    description?: string;
    /**
     * @deprecated
     */
    ugc_live_status?: UgcLiveStatus;
    /**
     * @deprecated
     */
    stream_uri?: string;
    broadcast_chat_path?: string;
    /**
     * Время, когда бэкенд отдаёт команду транслятору подняться
     */
    started_at?: number;
    display_name?: string;
    start_event_time?: number;
    is_legal_entity?: boolean;
    ended_at?: string | number;
}

interface VHLiveContent {
    xiva_id: string;
    viewers?: number;
    ugc_live_status?: UgcLiveStatus;
    start_time?: number;
}

export interface VHLiveResponse {
    content: VHLiveContent;
}

export interface BroadcastData {
    status: BroadcastStatus;
    broadcast_uri: string;
    started_at?: number;
    started_by?: string;
    broadcast_chat_path?: string;
    stream_uri?: string;
    access_level?: AccessLevel;
}
